import React from 'react';
import './Quiz.css';
import quiz1 from './images/match1.webp';
import quiz2 from './images/match2.webp';
import quiz3 from './images/match3.webp';
import quiz4 from './images/match4.webp';
import googlePlayLogo from './images/googleplay.webp';
import appStoreBadge from './images/appstore.webp';
import { Helmet } from 'react-helmet';

export default function Match() {
  const openGooglePlay = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.tkd.app&pcampaignid=web_share",
      "_blank"
    );
  };

  const openAppStore = () => {
    window.open(
      "https://apps.apple.com/us/app/tkd-study-itf-taekwondo/id6774597426",
      "_blank"
    );
  };

  return (
    <>
      <Helmet>
        <title>TKD Study - Match!</title>
      </Helmet>

      <div className="quiz-container">
        <h1 className="quiz-title">Match!</h1>

        <div className="back-arrow" onClick={() => window.history.back()}>
          ← Back
        </div>

        <p className="quiz-info">
          The tile match feature helps you learn your Korean Taekwondo terminology!
          <br /><br />
          Currently, Korean Match! is available in the <b>Android app</b> and <b>iOS app</b> only.
          <br />
          You can download it from the stores below to start practicing.
        </p>

        <div className="quiz-screenshots">
          <img src={quiz1} alt="Match Screenshot 1" />
          <img src={quiz2} alt="Match Screenshot 2" />
          <img src={quiz3} alt="Match Screenshot 3" />
          <img src={quiz4} alt="Match Screenshot 4" />
        </div>

        {/* Unified store buttons */}
        <div className="store-buttons">
          <img
            src={googlePlayLogo}
            alt="Google Play Badge"
            className="store-badge"
            onClick={openGooglePlay}
          />

          <img
            src={appStoreBadge}
            alt="App Store Badge"
            className="store-badge"
            onClick={openAppStore}
          />
        </div>
      </div>
    </>
  );
}